import { useQuery, UseQueryOptions } from 'react-query';

import { getCartItemsCount } from '../../graphql/index.2';

const QUERY_KEY = 'fetchCartItem';

const fetchCartItem = async (...params: Parameters<typeof getCartItemsCount>) => {
  try {
    const {
      data: { cart_items_count },
    } = await getCartItemsCount(...params);
    return cart_items_count;
  } catch (e) {
    console.error(QUERY_KEY, e);
    return 0;
  }
};

type CartItem = Awaited<ReturnType<typeof fetchCartItem>>;

interface QueryConfig extends Omit<UseQueryOptions<CartItem, unknown, CartItem, string[]>, 'queryKey' | 'queryFn'> {}

export const useCartItemsCountQuery = (config?: QueryConfig) => {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: () => fetchCartItem(null, { show_alert: false }),
    ...config,
  });
};
